import styled, { css } from "styled-components";

const smallMixin = css`
  text-align: left;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: flex-start;
`;

const mediumMixin = css`
  align-items: center;
`;

export const Container = styled.div`
  min-height: 300px;
  overflow: hidden;
  text-align: center;
  display: flex;
  flex-direction: column;

  ${({ size }) =>
    ["small", "medium", "desktop"].includes(size) ? smallMixin : ""}
  ${({ size }) => (["medium", "desktop"].includes(size) ? mediumMixin : "")}
`;

export const Age = styled.h1`
  display: block;
  width: 100%;
  font-weight: normal;
  box-sizing: border-box;
  text-align: center;
  background: #13bfbf;
  color: #ffffff6c;
  border-radius: 150px 0;
  padding: 1em;
  line-height: 1;
  font-size: 24px;
  margin-right: -2em;

  span {
    color: white;
    font-size: 56px;
    display: block;
    font-family: "Larsseit Medium", "Larsseit", "Roboto", sans-serif;
  }

  ${({ size }) =>
    ["small", "medium", "desktop"].includes(size)
      ? `
    margin-left: 2rem;
  `
      : ""}

  ${({ size }) =>
    ["medium", "desktop"].includes(size)
      ? `
    width: auto;
    padding: 4em 4.5em 4em 3.5em;
    span {
      font-size: 114px;
    }
  `
      : ""}
`;

export const Title = styled.h2`
  font-size: 36px;
  font-weight: normal;
  color: #292929;
  margin: 0;
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 200%;
  color: #888;
  margin: 2em 0;
  max-width: 727px;
`;

export const Photo = styled.img`
  width: 100%;
  max-width: 632px;
  max-height: 64px;
  user-select: none;
`;
